import { BasicoApi, CalculosApi } from '@common/api';

const ImportacaoService = {
  certificadosExcel: function (form) {
    return CalculosApi.post()('/ImportData/certificados-excel', form);
  },
  verificacaoIntermediariaExcel: function (form) {
    return CalculosApi.post()('/ImportData/verificacao-intermediaria-excel', form);
  },
  instrumentosExcel: function (form) {
    return BasicoApi.post()('/ImportData/instrumentos-excel', form);
  },
  instrumentosHistoricosExcel: function (form) {
    return BasicoApi.post()('/ImportData/instrumentos-historicos-excel', form);
  },
  criteriosAceitacaoExcel: function (form) {
    return BasicoApi.post()('/ImportData/criterios-aceitacao-excel', form);
  },
  listar: function (parametros) {
    return BasicoApi.get()('/ImportData', parametros);
  },
  buscaPorId: function (id, parametros) {
    return BasicoApi.get()(`/ImportData/${id}`, parametros);
  },
};

export default ImportacaoService;
